import { createContext, useContext } from 'react';

import type { SocketStatus } from './types';

export interface NotificationSocketValue {
  status: SocketStatus;
}

/**
 * Separado del archivo del provider para que el módulo exporte solo un
 * componente, que es lo que React Fast Refresh necesita para hot-reloadearlo en
 * vez de remontar el subárbol — y remontar el provider significa tirar el
 * socket en cada guardado. La misma razón por la que `authContext.ts` está
 * separado de `AuthProvider.tsx`.
 */
export const NotificationSocketContext = createContext<NotificationSocketValue>({
  status: 'closed',
});

export function useNotificationSocketStatus(): SocketStatus {
  return useContext(NotificationSocketContext).status;
}
